import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from "./App";
import reportWebVitals from './reportWebVitals';
import {LayoutProvider} from "./layout/context/LayoutContext";
import {PrimeReactProvider} from "primereact/api";
import "primeflex/primeflex.css";
import "primeicons/primeicons.css";
import "primereact/resources/primereact.css";
import "./styles/demo/Demos.scss";
import "./styles/layout/layout.scss";
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import {HelmetProvider} from "react-helmet-async";

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

root.render(
    // <React.StrictMode>
        <PrimeReactProvider>
            <HelmetProvider>
                <LayoutProvider>
                    <App/>
                </LayoutProvider>
            </HelmetProvider>
        </PrimeReactProvider>
    // </React.StrictMode>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.register();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();